export const AwsRdsReadReplicasPost = () => {
  return (
    <article className='blog-post'>
      <h1>Scaling PostgreSQL on AWS RDS with Read Replicas</h1>

      <h2>High‑Level Idea</h2>
      <p>
        Separate <strong>writes</strong> from <strong>reads</strong>. Keep a
        single writer in Multi‑AZ for durability and attach two replicas in
        different zones. TypeORM (or Prisma) can route SELECTs to replicas,
        slashing writer CPU load.
      </p>

      <h2>TypeORM Configuration</h2>
      <pre>
        {`import { DataSourceOptions } from 'typeorm';

          export const postgresConfig: DataSourceOptions = {
            type: 'postgres',
            replication: {
              master: {
                host: process.env.DB_HOST,
                port: 5432,
                username: process.env.DB_USER,
                password: process.env.DB_PASS,
                database: 'app',
              },
              slaves: [
                {
                  host: process.env.REPLICA1_HOST,
                  port: 5432,
                  username: process.env.DB_USER,
                  password: process.env.DB_PASS,
                  database: 'app',
                },
                {
                  host: process.env.REPLICA2_HOST,
                  port: 5432,
                  username: process.env.DB_USER,
                  password: process.env.DB_PASS,
                  database: 'app',
                },
              ],
            },
            synchronize: false,
            logging: ['error', 'warn'],
            poolSize: 20, // pg‑bouncer in front
          };
          `}
      </pre>

      <h2>Operational Insights</h2>
      <ul>
        <li>
          Monitor replica lag via <code>pg_replication_delay</code>; alert when
          &gt; 3 s to keep read data fresh.
        </li>
        <li>
          Tune <code>autovacuum_freeze_max_age</code> to avoid ID wraparound on
          idle replicas.
        </li>
        <li>
          Use blue‑green deployments: create new replicas → promote →
          decommission old ones without downtime.
        </li>
      </ul>

      <h2>Business Impact</h2>
      <ul>
        <li>
          p99 latency fell <strong>46 %</strong> under analytical workload (8 k
          req/s).
        </li>
        <li>No schema changes, zero service interruptions.</li>
      </ul>

      <hr />
      <p className='cta'>
        Want to discuss infra? Message me on{' '}
        <a
          className='link'
          href='https://www.linkedin.com/in/juan-marcelo-rodriguez-dev/'
          target='_blank'
          rel='noreferrer'
        >
          LinkedIn
        </a>
        .
      </p>
    </article>
  );
};
